import React from "react";
import Img from "gatsby-image";
import { getFluidGatsbyImage } from "gatsby-storyblok-image";
import cloudfrontConversion from "../utils/cloudfrontConversion";

const FluidImage = (props) => {
  const { image, className, ...rest } = props;


  const blur = props.blur || true;

  // Get image file name

  if (image?.filename == undefined){
    return null
  }

  const filename = image.filename;

  if (filename == null || filename == ""){
    return(
     null
    )
  }


  const fluidProps = getFluidGatsbyImage(image.filename, {
    maxWidth: 3120,
    quality: props.quality || 95,
    backgroundColor: "#A2E3BA"
  });

  if (fluidProps?.base64){
    // set to undefined 
    fluidProps['base64'] = undefined;
  }


  // replace src, srcSet, srcSetWebp, srcWebp urls with cdn urls via cloudfrontConversion

  fluidProps.src = cloudfrontConversion(fluidProps.src);
  fluidProps.srcSet = cloudfrontConversion(fluidProps.srcSet);
  fluidProps.srcSetWebp = cloudfrontConversion(fluidProps.srcSetWebp);
  fluidProps.srcWebp = cloudfrontConversion(fluidProps.srcWebp);

  return (
    <Img
      fluid={fluidProps}
      draggable={false}
      alt={image.alt}
      fadeIn
      className={className}
      backgroundColor="#A2E3BA"
      loading={props.critical ? `eager` : `lazy`}
    />
  );
};

export default FluidImage;